module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_1@3x.b707a5db.png";